import React from 'react';
import InputField from 'components/InputField';
import { SubmissionErrors } from 'final-form';
import { useTranslation } from 'react-i18next';
import { Form, FormProps } from 'react-final-form';
import { Button } from 'ncoded-component-library';
import { LocationType } from '../../InventoryLocationTypes.page';

import './LocationTypeForm.styles.scss';

type LocationTypeFormProps = {
  loading?: boolean;
  initialType: LocationType;
  className?: string;
  binNo?: number;
  onSubmit: (
    values: LocationType,
  ) => SubmissionErrors | Promise<SubmissionErrors> | void;
  handleCancel?: () => void;
} & FormProps<LocationType>;

const LocationTypeForm = (props: LocationTypeFormProps) => {
  const { initialType, onSubmit, handleCancel } = props;
  const { t } = useTranslation();

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ type: initialType?.type, id: initialType?.id }}
      render={(formRenderProps) => {
        const { handleSubmit, dirty } = formRenderProps;
        return (
          <form onSubmit={handleSubmit}>
            <InputField name="type" label={t('name')} placeholder={t('name')} />
            <div className="hhsa-manage-locations-type-form__actions">
              <Button
                type="button"
                onClick={handleCancel}
                variant="outline"
                className="hhsa-manage-locations-type-form__link"
              >
                <span>{t('cancel')} </span>
              </Button>
              <Button
                disabled={!dirty}
                type="submit"
                variant="solid"
                className="hhsa-manage-locations-type-form__actions__submit"
              >
                {initialType
                  ? t('InventoryLocationTypes.edit')
                  : t('InventoryLocationTypes.add')}
              </Button>
            </div>
          </form>
        );
      }}
    />
  );
};

export default LocationTypeForm;
